import { render, staticRenderFns } from "./AppointmentCapacityEdit.vue?vue&type=template&id=b0a83cde&scoped=true"
import script from "./AppointmentCapacityEdit.vue?vue&type=script&lang=js"
export * from "./AppointmentCapacityEdit.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCapacityEdit.vue?vue&type=style&index=0&id=b0a83cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a83cde",
  null
  
)

export default component.exports